import { render, staticRenderFns } from "./ContactWays.vue?vue&type=template&id=abadc372"
import script from "./ContactWays.vue?vue&type=script&lang=js"
export * from "./ContactWays.vue?vue&type=script&lang=js"
import style0 from "./ContactWays.vue?vue&type=style&index=0&id=abadc372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports